// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Sm126","selected":"_1dBoX","type1":"_1my-Q","type2":"_3PRiB"};